<template>
    <div id="app" :class="{'darkThemeMode': darkThemeMode, 'lightMode': !darkThemeMode}">
        <div>
            <layout-header />

            <div class="sdk-docs">
                <div class="container">
                    <div class="content" id="mainContent">
                        <router-view />
                    </div>
                </div>
            </div>
        </div>

        <layout-footer />
    </div>
</template>

<script>
import LayoutHeader from './components/Layout/Header'
import LayoutFooter from './components/Layout/Footer'
import { mapMutations, mapState } from 'vuex'
import { ToolsClass } from './classes/tools.class'

export default {
  name: 'app',
  components: {
    LayoutFooter,
    LayoutHeader
  },
  methods: {
    ...mapMutations([
      'setDarkThemeMode'
    ])
  },
  computed: {
    ...mapState({
      darkThemeMode: state => state.app.darkThemeMode
    })
  },
  created () {
    if (ToolsClass.getCookie('darkMode')) {
      this.setDarkThemeMode(true)
    }
  }
}
</script>

<style src="./assets/scss/App.scss" lang="scss"></style>
